






































































import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import {
  FetchState,
  ContactInformation
} from "@/shared/types";
import { Validator } from "vee-validate";
import * as _ from "lodash";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";

const defaultAddress = {
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  zip: "",
};

const initialState: ContactInformation = {
  firstName: "",
  middleInitial: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  isMailingSameAsPhysical: false,
  mailingAddress: { ...defaultAddress },
  physicalAddress: { ...defaultAddress },
  lastFourSsn: "",
  dateOfBirth: "",
  memberNumber: "",
  lastLogin: "",
  username: ""
};

@Component({
  components: {
    Button,
    ErrorSummary
  }
})
export default class ClaimContactInfo extends Vue {
  $validator: Validator;

  contactInfoStore = useContactInfoStore();


  isSubmitting = false;
  formModel: ContactInformation = null;
  isLoaded = false;

  @Watch("contactInfoStore.contactInformation")
  onContactInfoChanged () {
    this.initializeFromStateValue();
  }

  cloneToCurrentModel (o) {
    const clonedModel = _.cloneDeep(o);
    this.formModel = clonedModel;
    this.isLoaded = true;
  }

  initializeFromStateValue () {
    const contactInformation = this.contactInfoStore.contactInformation;
    if (this.contactInfoStore.contactInformationState === FetchState.Loaded && !contactInformation) {
      this.cloneToCurrentModel(initialState);
    } else if (contactInformation) {
      this.cloneToCurrentModel(contactInformation);
    } else {
      this.isLoaded = false;
    }
  }

  mounted (): void {
    this.initializeFromStateValue();
    this.contactInfoStore.getContactInformation();
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.$validator
        .validate()
        .then(result => {
          if (result) {
            return this.contactInfoStore.saveContactInformationClaimOnboarding({ ...this.formModel })
                .then(_ => this.$emit("complete"));
          }
        })
        .finally(() => this.isSubmitting = false);
  }

}
